import { Drawer } from "@mui/material";
import { handleDefaultProfile } from "../../../utils/helperFunctions";
import { IoClose } from "react-icons/io5";
import SideNav from "../SideNav";

const MobileSideNav = ({ openSideDrawer, currentUser, setOpenSideDrawer }) => {
  return (
    <div>
      <Drawer
        anchor="right"
        open={openSideDrawer}
        onClose={() => setOpenSideDrawer(false)}
        classes={{ paper: "w-full max-w-[320px] h-full" }}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 24,
            borderBottomLeftRadius: 24,
            boxShadow: "-4px 0 24px -4px rgb(0 0 0 / 0.12)",
          },
        }}
      >
        <div className="bg-[#372e5e] flex py-4 px-4 justify-between items-center">
          <div>
            <img
              src="/static/images/seekho-black.webp"
              alt="seekho"
              className="w-[100px]"
            />
          </div>

          <button
            onClick={() => setOpenSideDrawer(false)}
            className="p-2 rounded-xl hover:bg-white/10 transition-colors"
          >
            <IoClose className="w-6 h-6 text-white" />
          </button>
        </div>

        <div className="flex mt-4 items-start gap-x-4 px-4 pb-4 bg-[#372e5e] md:block">
          <img
            src={
              handleDefaultProfile({
                userName: currentUser?.name || currentUser?.email?.split("@")[0],
                avatar: currentUser?.avatar,
              })
            }
            alt={currentUser?.name}
            className="w-16 h-16 md:w-20 md:h-20 rounded-2xl md:m-auto select-none object-cover ring-2 ring-white/20"
          />

          <div className="md:!text-center mt-2 text-[12px] text-white">
            <p>Welcome,</p>
            <p className="mt-1 font-semibold">
              {currentUser?.name || currentUser?.email?.split("@")[0] || "User"}
            </p>
          </div>
        </div>

        <div className="mt-0 px-2 bg-[#372e5e]">
          <SideNav displayLogo={false} />
        </div>
      </Drawer>
    </div>
  );
};

export default MobileSideNav;
